export default {
  unknown: 'Unknown',
} as const;
